import { render } from "./modifyPassword.vue?vue&type=template&id=62f401bf&scoped=true"
import script from "./modifyPassword.vue?vue&type=script&lang=js"
export * from "./modifyPassword.vue?vue&type=script&lang=js"

import "./modifyPassword.vue?vue&type=style&index=0&id=62f401bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f401bf"]])

export default __exports__